import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';
import { UseFilteredSearchReturn } from '@hooks/useFilteredSearch';
import { Text } from '@components/index';
import { SearchFigma } from '@components/SearchBars';
import { FilterSection, StyledDiv } from './Heading.styles';
import { FilterMenu } from '../FilterMenu/FilterMenu';
import { AddDocumentMenu } from '../AddDocumentMenu';
import { FilterContent } from '../FilterContent/FilterContent';

type HeadingProps = UseFilteredSearchReturn<GetDocumentsByStudioFilter>;
export function Heading(props: HeadingProps) {
  const { filterFns, pageFilter } = props;

  function onClear() {
    filterFns.searchBy('');
  }
  return (
    <StyledDiv>
      <Text text="h800" textColor="n900">
        Documents
      </Text>
      <FilterSection>
        <SearchFigma startSearch={filterFns.searchBy} onClear={onClear} />
        <FilterMenu
          filter={pageFilter.filter}
          content={close => {
            return (
              <FilterContent
                filterFns={filterFns}
                close={close}
                pageFilter={pageFilter}
              />
            );
          }}
        />
        <AddDocumentMenu />
      </FilterSection>
    </StyledDiv>
  );
}
